// <auto-generated>
// Generated from contracts/renderer-bridge.json by openapi-typescript 7.13.0 (pnpm contracts:generate). Do not edit.
// contract-sha256: 586a8d042f78b972f6777d75df2b3298d2ee126ce15c06715160e4de742a1a4e
// </auto-generated>
export const EDITOR_TO_RENDERER_MESSAGE_TYPES = [
  "setJwt",
  "checkCanvasReady",
  "requestScreenshot",
  "timelinePlay",
  "timelinePause",
  "timelineStop",
  "timelineSeek",
  "assetInstanceAdded",
  "assetInstanceUpdated",
  "assetInstanceLockChanged",
  "assetInstanceVisibilityChanged",
  "assetInstanceRemoved",
  "keyframeAdded",
  "keyframeUpdated",
  "keyframeRemoved",
  "clipInstanceAdded",
  "clipInstanceUpdated",
  "clipInstanceRemoved",
  "uiElementInstanceAdded",
  "uiElementInstanceUpdated",
  "uiElementInstanceRemoved",
  "materialInstanceUpserted",
  "materialInstanceRemoved",
  "vfxInstanceAdded",
  "vfxInstanceUpdated",
  "vfxInstanceRemoved",
  "selectKeyframe",
  "clearSelection",
  "setCamera",
  "recenterView",
  "setSkybox",
  "setViewportTheme",
  "setZoomSensitivity",
  "readAfter",
  "readHomeUntil",
] as const;

export const RENDERER_TO_EDITOR_MESSAGE_TYPES = [
  "requestJwt",
  "rendererLoaded",
  "rendererError",
  "pointerDown",
  "keyboardEvent",
  "canvasReadyResponse",
  "screenshotResponse",
  "sceneLoaded",
  "assetInstanceLoaded",
  "assetInstanceSelected",
  "selectionCleared",
  "keyframeSelected",
  "cameraToggled",
  "assetInstanceTransformsEdited",
  "keyframeTransformsEdited",
  "assetInstanceRequested",
  "clipTypesDiscovered",
] as const;
